// ---------- START IMPORT BLOCK ----------
import APIService from '../Core/APIService';
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import type { SkillRead } from "../../Types/schema-helpers";
// ---------- END IMPORT BLOCK ----------

export default class SkillsService extends APIService {
  /**
   * Searches skills by query string.
   */
  async searchSkills(
    query: string,
    signal?: AbortSignal
  ): Promise<SkillRead[]> {
    const route = API_ROUTES.search_skills(query);
    const config = signal ? { signal } : undefined;
    return this.get<SkillRead[]>(route, config);
  }
}